export enum KnownUTMSource {
  BUSINESS_ACCOUNTS = 'business-account-lander'
}

export interface UTMParams {
  source?: KnownUTMSource | string
  medium?: string
  campaign?: string
  term?: string
  content?: string
}

export function parseUTM(url: string | URL): UTMParams {
  const qs = (typeof url === 'string' ? new URL(url) : url).searchParams
  const get = (k: string) => qs.get(`utm_${k}`) ?? undefined

  return {
    source: get('source'),
    medium: get('medium'),
    campaign: get('campaign'),
    term: get('term'),
    content: get('content')
  }
}
